import graphql from "babel-plugin-relay/macro";

const DocumentsForReviewQuery = graphql`
  query DocumentsForReviewQuery(
    $after: String
    $first: Int
    $sort: String
    $justMine: Boolean
  ) {
    documentsToReview(justMine: $justMine, sort: $sort) {
      documents(after: $after, first: $first) {
        totalCount
        edges {
          node {
            pk
            name
            category {
              name
            }
            expirationDate
            restricted
            preview
            bloc {
              name
            }
            isHomeBloc
            author {
              firstName
              lastName
              title
            }
            cannotBulkReviewReason
          }
        }
      }
      buckets
      showBulkReview
      rssFeedUrl
    }
  }
`;

export default DocumentsForReviewQuery;
